import ConstantsStorage from '../../constants/index';
import VideosessionApi from '../../api/videosession';
import {buildRoute} from '../../configs/routes';
import URL_MAP from '../../constants/urls';
import {ActionRouteNavigate} from './actions-route';
import CommonAPI from '../../api/common';
import {ActionModalHide, ActionModalShowInvitedDeclined} from './actions-modal';
import {NotificationError, NotificationSuccess} from '../../services/notifications';

const Constants = ConstantsStorage();

export function ActionStoreVideoSessionData(key, data, remember) {
  return {
    type: Constants.VIDEOSESSION_ACTIONS.UPDATE,
    key,
    data,
    remember,
  };
}

export function ActionCheckAvailabilityVideoSession(videosessionId) {
  return (dispatch) => {
    VideosessionApi.checkAvailabilityVideosession(videosessionId).then((res) => {
      const response = res || {};
      dispatch(ActionStoreVideoSessionData('isAvailable', response.isAvailable));
      if (!res.isAvailable) {
        alert('Извините, видеосессия не доступна!');
        dispatch(ActionRouteNavigate(buildRoute(URL_MAP.VIDEO_SESSION)));
        dispatch(ActionStoreVideoSessionData('isAvailable', false));
      }
    }).catch((error) => {
      dispatch(ActionStoreVideoSessionData('isAvailable', false));
      alert('Извините, видеосессия не доступна!');
      dispatch(ActionRouteNavigate(buildRoute(URL_MAP.VIDEO_SESSION)));
    }).finally(() => {
    });
  };
}

export function ActionCleanVideoSessionData() {
  return (dispatch) => {
    dispatch(ActionStoreVideoSessionData('isAvailable', false));
    dispatch(ActionStoreVideoSessionData('_id', null));
  };
}

export function ActionAcceptInviteVideosession(videosessionId) {
  return (dispatch) => {
    dispatch(ActionCleanVideoSessionData());
    dispatch(ActionRouteNavigate(buildRoute(URL_MAP.CALL, videosessionId)));
    dispatch(ActionCheckAvailabilityVideoSession(videosessionId));
    VideosessionApi.acceptInviteVideosession(videosessionId).then((res) => {
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionDeclineInviteVideosession(videosessionId) {
  return (dispatch) => {
    // VideosessionApi.declineInviteVideosession(videosessionId).then((res) => {
    //   console.log(res);
    // }).catch((error) => {
    //   NotificationError(error.error_description || error.message);
    // }).finally(() => {
    // });
  };
}

export function ActionCancelInviteVideosession(videosessionId, userId) {
  return (dispatch, getState) => {
    VideosessionApi.cancelInviteVideosession(videosessionId, userId).then((res) => {
      const state = getState().rVideoSession || {};
      const streams = state.streams || [];
      const newStreams = streams.map((st) => {
        if (st.inviteData) {
          if (st.inviteData._id === userId) {
            const newStream = {...st};
            newStream.inviteData = null;
            return newStream;
          }
        }
        return st;
      });
      dispatch(ActionStoreVideoSessionData('streams', newStreams));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {

    });
  };
}

export function ActionSetInvitedUserData(contact, stream) {
  return (dispatch, getState) => {
    const state = getState().rVideoSession || {};
    const streams = state.streams || [];
    const newStreams = streams.map((st) => {
      if (stream.index === st.index) {
        const newSt = {...st};
        const inviteData = {...contact, inviteTime: new Date()};
        newSt.inviteData = inviteData;
        return newSt;
      }
      return st;
    });
    dispatch(ActionStoreVideoSessionData('streams', newStreams));
  };
}

export function ActionInviteEmailVideosession(data) {
  return (dispatch, getState) => {
    const params = data;
    const userId = getState().rUser._id;
    params.userId = userId;
    CommonAPI.inviteEmailVideosession(params).then((res) => {
      dispatch(ActionModalHide());
      NotificationSuccess('Приглашениие успешно отправлено!');
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionInviteOnlineVideosession(data, contact, stream) {
  return (dispatch) => {
    CommonAPI.inviteOnlineVideosession(data).then((res) => {
      dispatch(ActionSetInvitedUserData(contact, stream));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionSetVideoStreams(streams, callback = () => {}) {
  return (dispatch) => {
    dispatch(ActionStoreVideoSessionData('streams', streams));
    callback();
  };
}

export function ActionCallInvitedDeclined(data = {}) {
  return (dispatch, getState) => {
    const userId = data.user;
    const state = getState().rVideoSession || {};
    const streams = state.streams || [];
    const newStreams = streams.map((stream) => {
      const newStream = {...stream};
      const invitedData = stream.inviteData || {};
      if (invitedData._id === userId) {
        dispatch(ActionModalShowInvitedDeclined({data: {...invitedData, declinedDate: data.date}}));
        newStream.inviteData = null;
      }
      return newStream;
    });
    dispatch(ActionSetVideoStreams(newStreams));
  };
}
